import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@src/App';
import 'normalize.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
        <App />
  </React.StrictMode>
);

// Add HMR fallback
if (module.hot) {
  module.hot.accept('@src/App', () => {
    const NextApp = require('@src/App').default;
    root.render(
      <React.StrictMode>
        <NextApp />
      </React.StrictMode>
    );
  });
}
